<template>
  <div class="simple-category-widget">
    <div
      v-for="(row, i) in widgetData"
      :key="i"
      :class="[
        'data-item',
        { selectable: !disable },
        { active: !inActive },
        { highlight: row.isActive },
      ]"
      @click.prevent="
        toggleFilter({ item_id: row.id, isActive: !row.isActive })
      "
    >
      <div class="meta-row">
        <p class="title">{{ row.name }}</p>
        <p>{{ row.value }}</p>
      </div>
      <div :class="['progress-track']">
        <div
          :class="['progress-thumb', { active: row.isActive }]"
          :style="`width: ${row.percentage}%`"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "@/lib/numberFormatter";
import cloneDeep from "lodash/cloneDeep";

export default {
  props: {
    value: Array,
    disable: Boolean,
    inActive: Boolean,
  },
  computed: {
    widgetData() {
      // calculate the total of all the values
      let total =
        this.value &&
        this.value.length > 0 &&
        this.value
          .map((item) => item.value)
          .reduce((prev, next) => {
            prev += parseFloat(next);
            return prev;
          });

      // format values and add percentages
      return (
        this.value &&
        this.value.map((item) => {
          let value = parseFloat(item.value);
          value = isNaN(value) ? 0 : value;
          value = format(value.toFixed(0), 2);
          const newItem = {
            ...item,
            percentage: Math.round((parseFloat(item.value) / total) * 100),
            value,
          };
          return newItem;
        })
      );
    },
  },
  methods: {
    toggleFilter(data) {
      this.$emit("input", data);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.simple-category-widget {
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  .data-item {
    display: flex;
    flex-direction: column;
    min-height: 50px;
    margin: 0 15px;

    .meta-row {
      display: flex;
      flex-direction: row;
      align-items: center;

      p {
        margin: 0;
        padding: 0;
      }
      .title {
        flex: 1;
      }
    }

    &.active {
      .progress-track .progress-thumb {
        background-color: var(--font-color);
      }
    }

    &.highlight {
      color: var(--color-primary);
      font-weight: bold;
    }

    &.selectable:hover {
      cursor: pointer;
      .progress-track {
        /* background-color: var(--color-secondary); */
      }
    }

    .progress-track {
      position: relative;
      background-color: var(--border-color);
      min-height: 6px;
      border-radius: 10px;
      margin-top: 5px;

      .progress-thumb {
        position: absolute;
        left: 0;
        min-height: 6px;
        border-radius: 10px;
        background-color: var(--font-color);
        opacity: 0.5;

        &.active {
          background-color: var(--color-accent);
          opacity: 1;
        }
      }
    }
  }
}
</style>
